import React from 'react';
import { isMobile } from '@/utils';

function NurseryOpendayDetailService(props) {
  if (isMobile()) {
    const Mobile = require('./Detail').default;
    return <Mobile {...props} />;
  }
  const Web = require('./WebDetail').default;
  return <Web {...props} />;
}

export default NurseryOpendayDetailService;
